import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, HostListener } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TypePolicyService } from 'src/app/service/typePolicy.service';
import { TypePolicyModel } from 'src/app/model/typePolicy.model';
import { PolicyService } from 'src/app/service/policy.service';
import { SearchParamsModel } from 'src/app/model/search-params.model';
import { PolicyModel } from 'src/app/model/policy.model';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { InstanceService } from 'src/app/service/instance.service';
import swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { DesignService } from 'src/app/service/design.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MotorPolicyService } from 'src/app/service/motor-policy.service';
import { AuthenticationService } from 'src/app/service/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-process-filter',
  templateUrl: './process-filter.component.html',
  styleUrls: ['./process-filter.component.scss']
})
export class ProcessFilterComponent implements OnInit {

  listExcel: any[];
  itemExcel: any;
  currentMenuConfig: AttributeModel;
  isDropdownOpen: boolean = false;
  importPolicyId: string;
  showAdvancedSearch = false;
  filterPolicyId: string;

  filters: AttributeModel[] = []
  @Input() searchParams: SearchParamsModel
  @Output() search: EventEmitter<any> = new EventEmitter()
  @Output() export: EventEmitter<any> = new EventEmitter()
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;

  constructor(
    private policyService: PolicyService,
    private typePolicyService: TypePolicyService,
    private instanceService: InstanceService,
    private designService: DesignService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private elementRef: ElementRef,
    private motorPolicyService: MotorPolicyService,
    private http: HttpClient,
    private authService: AuthenticationService
  ) { }

  get createLinks(): AttributeModel[] {
    if (this.currentMenuConfig) {
      const createAttr = this.currentMenuConfig.attributes
        .find(attr => attr.key.toLowerCase() == "create");

      if (createAttr) {
        return createAttr.attributes
          .filter(attr => attr.type.toLowerCase() == "link");
      }
    }

    return [];
  }

  get exportExcelAttr(): AttributeModel  {
    if (this.currentMenuConfig) {
      return this.currentMenuConfig.attributes
        .find(attr => attr.key.toLowerCase() == "export excel");
    }

    return null;
  }

  get exportExcelTitle(): string  {
    if (this.exportExcelAttr) {
      return this.exportExcelAttr.value;
    }

    return "";
  }

  get importExcelAttr(): AttributeModel  {
    if (this.currentMenuConfig) {
      return this.currentMenuConfig.attributes
        .find(attr => attr.key.toLowerCase() == "import excel");
    }

    return null;
  }

  get importExcelTitle(): string  {
    if (this.importExcelAttr) {
      return this.importExcelAttr.value;
    }

    return "";
  }

  get shouldShowExport(): boolean {
    if (this.currentMenuConfig && this.exportExcelTitle) {
      return true;
    }

    return false;
  }

  get shouldShowImport(): boolean {
    if (this.currentMenuConfig && this.importExcelAttr) {
      return true;
    }

    return false;
  }

  async ngOnInit() {
    this.route.params.subscribe(async params => {
      this.currentMenuConfig = this.designService.getCurrentMenuConfig();
      this.showAdvancedSearch = false;
      await this.loadFiltersAsync();
    });

    $("#search").click(function (e) {
      e.preventDefault();
      $(".search-advanced").slideToggle('slow');
    });
  }

  private async loadFiltersAsync(): Promise<void> {
    const typePolicies: TypePolicyModel[] = await this.typePolicyService.list().toPromise();
    const type = typePolicies.find(t => t.options.some(opt => opt.key.toLowerCase() === 'type' && opt.value.toLowerCase() === 'filter'));
  
    this.filters = [];
  
    if (type) {
      const policies: PolicyModel[] = await this.policyService.listByTypePolicy(type.id).toPromise();
      if (policies && policies.length > 0) {
        this.filterPolicyId = policies[0].id;
        const policyResponse = await this.motorPolicyService.getBy(policies[0].id).toPromise();
        
        if (policyResponse) {
          const filterAttribute = policyResponse.attributes.find(attr => 
            attr.value != null && attr.value != "" && this.currentMenuConfig.value.includes(attr.value));
  
          if (filterAttribute) {
            this.filters = filterAttribute.attributes;
          }
        }
      }
    }
  
    this.loadSearchParams();
  }

  private async updateFiltersOnChange(filter: AttributeModel): Promise<void> {
    const shouldUpdate = filter.options?.some(opt => 
      opt.key.toLowerCase() === "perform front-end update" && 
      opt.value.toLowerCase() === "true"
    );

    if (shouldUpdate && filter.value) {
      const updateDataField = filter.options?.find(opt => 
        opt.key.toLowerCase() === "update data field"
      );

      if (updateDataField) {
        const updateAttribute = {
          key: updateDataField.value,
          value: filter.value,
          type: "Text"
        };

        try {
          const queryParams = `?attributes[0].key=${updateAttribute.key}&attributes[0].value=${updateAttribute.value}&attributes[0].type=${updateAttribute.type}`;
          const updatedPolicy = await this.motorPolicyService
            .getWithComplement<PolicyModel>(`${this.filterPolicyId}${queryParams}`)
            .toPromise();

          if (updatedPolicy) {
            const filterAttribute = updatedPolicy.attributes.find(attr => 
              attr.value != null && attr.value != "" && this.currentMenuConfig.value.includes(attr.value));

            if (filterAttribute) {
              const currentValue = filter.value;
              const prevSelectedMeta = filter.attributes?.find(a => a.type?.toLowerCase() === 'filterselectedoption');

              this.filters = filterAttribute.attributes;
              
              const updatedFilter = this.filters.find(f => f.key === filter.key);
              if (updatedFilter) {
                // preserva o valor selecionado
                updatedFilter.value = currentValue;

                // preserva o metadado FilterSelectedOption (mantém chave/label selecionados)
                if (prevSelectedMeta) {
                  let meta = updatedFilter.attributes?.find(a => a.type?.toLowerCase() === 'filterselectedoption');
                  if (!meta) {
                    if (!updatedFilter.attributes) { (updatedFilter as any).attributes = []; }
                    updatedFilter.attributes.push({
                      key: prevSelectedMeta.key,
                      value: prevSelectedMeta.value,
                      type: prevSelectedMeta.type,
                      attributes: [...(prevSelectedMeta.attributes || [])],
                      options: [...(prevSelectedMeta.options || [])]
                    } as any);
                  } else {
                    meta.value = prevSelectedMeta.value;
                    meta.attributes = [...(prevSelectedMeta.attributes || [])];
                    meta.options = [...(prevSelectedMeta.options || [])];
                  }
                }
              }
            }
          }
        } catch (error) {
          console.error('Erro ao atualizar filtros:', error);
        }
      }
    }
  }

  private getSearchParamsKey(): string | null {
    if (!this.currentMenuConfig || !this.currentMenuConfig.value) {
      console.warn('currentMenuConfig or value is not defined.');
      return null;
    }
  
    const isPolicy = this.currentMenuConfig.value.includes('policy');
    const prefix = isPolicy ? 'policy' : 'type';
    const id = this.getPolicyOrTypeId();
  
    if (!id) {
      console.warn('Policy or Type ID not found. Skipping sessionStorage update.');
      return null;
    }
  
    return `searchParams_${prefix}_${id}`;
  }

  private getPolicyOrTypeId(): string {
    const value = this.currentMenuConfig.value;
    const match = value.match(/(policy|type)\/(.+)/);
    return match ? match[2] : '';
  }

  private async loadSearchParams() {
    const key = this.getSearchParamsKey();
  
    if (!key) {
      console.error('Unable to load search params. Key is invalid or missing.');
      return;
    }
  
    if (sessionStorage.getItem(key)) {
      this.searchParams = JSON.parse(sessionStorage.getItem(key));
    }
  
    this.searchParams.orderDesc = true;
  
    Object.keys(this.searchParams).forEach(key => {
      if (!Array.isArray(this.searchParams[key])) {
        this.setParamIntoFilterByFieldName(key, this.searchParams[key]);
      }
    });
  
    if (this.searchParams.attributes) {
      this.searchParams.attributes.forEach(attr => {
        this.setParamIntoFilterByAttribute(attr);
      });
    }

    for (const filter of this.filters) {
      if (filter.value) {
        await this.updateFiltersOnChange(filter);
      }
    }
  }

  private setParamIntoFilterByFieldName(fieldName: string, value: string) {
    let filter = this.filters.find(f =>
      f.options.some(opt => opt.key == "searchField" && opt.value == fieldName))

    if(filter && value){
      let binding = filter.attributes.find(attr => attr.key.toLocaleLowerCase() == 'binding')
      if(binding.value || this.isValueInBindingList(binding, value)) {
        filter.value = value
        this.showAdvancedSearch = true;
      }else{
        this.searchParams[fieldName] = ''
        const key = this.getSearchParamsKey();
        sessionStorage.setItem(key, JSON.stringify(this.searchParams));
        this.search.emit()
      }
    }
  }

  private isValueInBindingList(binding: AttributeModel, value: string):boolean {
    return binding.attributes.some(opt => opt.value.toLocaleLowerCase() == value.toLocaleLowerCase());
  }

  private setParamIntoFilterByAttribute(attribute: AttributeModel) {
    let filter = this.filters.find(f => f.key == attribute.key)

    if(filter) {
      filter.value = attribute.value;

      if (filter.value) {
        this.showAdvancedSearch = true;
      }
    }
  }

  createNewRecord(attribute: AttributeModel) {
    const policyIdOpt = attribute.options.find(opt => opt.key.toLowerCase() == "policyid");

    if (policyIdOpt && policyIdOpt.value) {
      this.router.navigate([`processes/process/edit/${policyIdOpt.value}`]);
      return;
    }

    const targetEndpointAttr = (attribute.attributes || []).find(
      attr => attr.key?.toLowerCase() === 'targetendpoint'
    );
    if (targetEndpointAttr && targetEndpointAttr.value) {
      const successMessageOpt = targetEndpointAttr.options?.find(
        opt => opt.key.toLowerCase() === 'successmessage'
      );
      const methodOpt = targetEndpointAttr.options?.find(
        opt => opt.key.toLowerCase() === 'httpmethod'
      );
      const url = `${environment.apiUrl}/${targetEndpointAttr.value}`;
      const method = (methodOpt?.value || 'post').toLowerCase();

      if (method !== 'post' && method !== 'put' && method !== 'patch') {
        return;
      }

      this.spinner.show();
      const headers = new HttpHeaders().set("Authorization", `Bearer ${this.authService.getToken()}`);
      const request$ =
        method === 'post'
          ? this.http.post(url, {}, { headers })
          : method === 'put'
          ? this.http.put(url, {}, { headers })
          : this.http.patch(url, {}, { headers });

      request$.subscribe(
        () => {
          this.spinner.hide();
          if (successMessageOpt?.value) {
            swal.fire("Sucesso!", `${successMessageOpt.value}`, "success");
          } else {
            swal.fire("Sucesso!", `Ação ${attribute.key} realizada.`, "success");
          }
        },
        () => {
          this.spinner.hide();
          swal.fire("Atenção", "Falha ao executar a ação.", "error");
        }
      );
      return;
    }

    const routeOpt = attribute.options.find(opt => opt.key.toLowerCase() == "route");

    if (routeOpt && routeOpt.value) {
      this.router.navigate([`${routeOpt.value}`]);
    }
  }

  doExport() {
    this.buildSearch();
    this.export.emit()
  }

  doSearch() {
    this.buildSearch();
    this.search.emit()
  }

  doSearchByName() {
    const key = this.getSearchParamsKey();
  
    if (!key) {
      console.error('Cannot save search params. Key is invalid or missing.');
      return;
    }
  
    sessionStorage.setItem(key, JSON.stringify(this.searchParams));
    this.doSearch();
  }

  buildSearch() {
    this.searchParams.attributes = [];
  
    this.filters.forEach(filter => {
      this.buildSearchParams(filter);
    });
  
    const key = this.getSearchParamsKey();
    if (!key) {
      console.error('Cannot build search params. Key is invalid or missing.');
      return;
    }
  
    sessionStorage.setItem(key, JSON.stringify(this.searchParams));
  }

  buildSearchParams(filter: AttributeModel) {
    let filterPath = filter.attributes.find(attr => attr.type == "filterPath")

    if(filterPath){
      let searchField = filter.options.find(opt => opt.key == "searchField")
      const binding = filter.attributes.find(attr => attr.key?.toLowerCase() === 'binding' || attr.type?.toLowerCase() === 'binding')
      const bindingOptions = binding?.attributes || []
      const selectedOptionMeta = filter.attributes.find(attr => attr.type?.toLowerCase() === 'filterselectedoption')

      let selectedKey = filter.value
      if (selectedKey == null || selectedKey === '') {
        selectedKey = null
      } else if (selectedOptionMeta && selectedOptionMeta.attributes?.length) {
        selectedKey = selectedOptionMeta.attributes[0].key || null
      } else if (bindingOptions.length) {
        const selected = bindingOptions.find(o => o.key == filter.value) || bindingOptions.find(o => (o.value || '').toLowerCase() === String(filter.value).toLowerCase())
        selectedKey = selected ? selected.key : null
      } else {
        selectedKey = filter.value
      }
      filterPath.attributes.forEach(o => o.value = selectedKey)

      if(searchField) {
        if (selectedKey != null && selectedKey !== '') {
          this.searchParams[searchField.value] = selectedKey
        } else {
          this.searchParams[searchField.value] = ''
        }
      } else {
        this.searchParams.attributes.push(filter)
      }
    }
  }

  getSizeClass(attribute: AttributeModel): string {
    if (!attribute.options) {
        return "col-md-12"
    }

    let size = attribute.options
        .find(option => option.key == "size-class")

    if (size) {
        return size.value
    }else{
      return "col-md-12"
    }
  }

  async handle(events: DynamicEvent[]) {
    events.forEach(async event => {
      if(event.name == "doSearch") {
        this.doSearch()
      }

      const filter = event.attribute;
      if (filter) {
        await this.updateFiltersOnChange(filter);
      }
    })
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;

    if (this.isDropdownOpen && !this.elementRef.nativeElement.contains(targetElement)) {
      this.isDropdownOpen = false;
    }
  }

  handleDropdownOption(option: AttributeModel): void {
    if (option.key.toLowerCase() == "upload file") {
      const policyIdOpt = option.options
        .find(opt => opt.key.toLowerCase() == "policyid");
      
      if (policyIdOpt) {
        this.openImportDialog(policyIdOpt.value);
      }
    } else {
      const pathOpt = option.options
        .find(opt => opt.key.toLowerCase() == "path");

      if (pathOpt && pathOpt.value) {
        window.open(pathOpt.value, '_blank');
      }
    }
  
    this.isDropdownOpen = false;
  }

  openImportDialog(policyId: string) {
    this.importPolicyId = policyId;
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any) {
    this.spinner.show();
    const file: File = event.target.files[0];

    if (file) {
      const policyId = this.searchParams.policyId 
        ? this.searchParams.policyId 
        : this.importPolicyId; 

      this.instanceService.import(policyId, file).subscribe(
        (response) => {
          this.spinner.hide();
          swal.fire('Sucesso', 'O arquivo foi importado com sucesso!', 'success');
          this.resetFileInput();
          this.doSearch();
        },
        (error) => {
          this.spinner.hide();
          this.resetFileInput();
          swal.fire('Erro', 'Falha na importação do arquivo.', 'error');
        }
      );
    }
  }

  resetFileInput() {
    this.fileInput.nativeElement.value = '';
  }

  toggleAdvancedSearch(): void {
    this.showAdvancedSearch = !this.showAdvancedSearch;
  }

  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }
}